import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-page-navigation',
  templateUrl: './page-navigation.component.html',
  styleUrls: ['./page-navigation.component.scss']
})
export class PageNavigationComponent implements OnInit {
  @Output() loadPage = new EventEmitter<number>();
  @Input() page: number;
  @Input() totalPages: number;

  constructor() { }

  ngOnInit() {
  }
  
}



// WEBPACK FOOTER //
// ./src/app/shared/page-navigation.component.ts